import { render } from "./MealTypesView.vue?vue&type=template&id=896f41d0"
import script from "./MealTypesView.vue?vue&type=script&lang=js"
export * from "./MealTypesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__